import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MyDatePickerModule } from 'mydatepicker';
import { EmployeeActivateRoutingModule } from './employee-activate-routing.module';
import { EmployeeActivateComponent } from './components/employee-activate.component';
import { EmployeeActivateService } from './services/employee-activate.service'
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    EmployeeActivateRoutingModule,
    FormsModule,
    MyDatePickerModule,
    TranslateModule.forChild(),
    TextMaskModule
  ],
  declarations: [EmployeeActivateComponent],
  providers:[EmployeeActivateService]
})
export class EmployeeActivateModule { }
